export default __webpack_public_path__ + "static/medicare-3274b71e2724ae77afc2477e0216cdff.svg";